module.exports = __webpack_public_path__ + "img/diderot.d558e0c1.png";